import React, { Fragment } from 'react';

import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { IconButton, Tooltip } from '@mui/material';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

import { SensorMappingModel } from '../SensorMappingModel';

const renderOverride = (params: GridRenderCellParams<any, any, any>, onEditOverrideClick: any) => {
  const row: SensorMappingModel = params.row;

  const editOverrideClickHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation(); // Prevent grid row click and other default actions
    onEditOverrideClick(row);
  };

  return (
    <Fragment>
      <Tooltip
        title={row.override || 'No sensor name override'}
        enterDelay={350}
        enterNextDelay={350}
      >

        {row.override ?
          <div className="data-grid-cell-ellipsis data-grid-cell-pointer">
            {row.override}
          </div>
          :
          <div className="data-grid-cell-ellipsis data-grid-cell-pointer" style={{opacity: 0.5}}>
            N/A
          </div>
        }
      </Tooltip>

      <Tooltip
        title={'Override sensor name'}
        enterDelay={350}
        enterNextDelay={350}
      >
        <IconButton
          size="small"
          style={{marginLeft: 'auto'}}
          onClick={editOverrideClickHandler}
        >
          <DriveFileRenameOutlineIcon fontSize="medium" color="primary"/>
        </IconButton>
      </Tooltip>
    </Fragment>
  );
};

const renderSensorName = (params: GridRenderCellParams<any, any, any>) => {
  const row: any = params.row;
  return (
    <Tooltip
      title={row.sensor || 'No sensor name'}
      enterDelay={350}
      enterNextDelay={350}
    >
      <div className="data-grid-cell-ellipsis data-grid-cell-pointer">
        {row.sensor || 'N/A'}
      </div>
    </Tooltip>
  );
};

const remInPixels = parseFloat(getComputedStyle(document.documentElement).fontSize);

export const sensorMappingColumns = (onEditOverrideClick: any): GridColDef[] => [
  { field: 'sensor', renderCell: renderSensorName, headerName: 'Sensor Name', flex: 1 },
  {
    field: 'override',
    renderCell: (params) => renderOverride(params, onEditOverrideClick),
    headerName: 'Sensor Override',
    flex: 1
  },
  { field: 'tag', headerName: 'RDS-PS Tag', width: 10 * remInPixels }
];
